import {api} from '@/api/factory';

class Studio {
    constructor() {}

    getDomains() {
        return api.get('/v1/studio/domains');
    }

    addDomain(domain: string) {
        return api.post('/v1/studio/domains', { domain });
    }

    removeDomain(id: number) {
        return api.delete(`/v1/studio/domains/${id}`);
    }
}

export default Studio
